import { useEffect, useRef, useState } from "react";
import { CreditCard } from "lucide-react";

export function PayPalButton({ hostedButtonId }) {
  const rendered = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!hostedButtonId || rendered.current) return;
    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      if (window.paypal?.HostedButtons) {
        clearInterval(timer);
        try {
          window.paypal.HostedButtons({ hostedButtonId }).render(`#paypal-container-${hostedButtonId}`);
          rendered.current = true;
        } catch (e) {
          setError(true);
        }
      } else if (tries > 40) {
        clearInterval(timer);
        setError(true);
      }
    }, 250);
    return () => clearInterval(timer);
  }, [hostedButtonId]);

  if (error) {
    return (
      <a
        href={`https://www.paypal.com/ncp/payment/${hostedButtonId}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`paypal-btn-${hostedButtonId}`}
        className="mt-3 flex items-center justify-center gap-2 border border-yellow-600/50 text-yellow-500 hover:bg-yellow-600/10 font-semibold text-sm py-2.5 rounded-full transition-colors duration-200"
      >
        <CreditCard className="w-4 h-4" />
        Pagar con PayPal
      </a>
    );
  }
  return <div id={`paypal-container-${hostedButtonId}`} data-testid={`paypal-btn-${hostedButtonId}`} className="mt-3 min-h-[40px]" />;
}
